module.exports = __webpack_public_path__ + "img/wholesale6.515adcc6.png";